import { BasicCrudService } from '@/app/common/utils/crud/basic-crud.service';
import { Injectable } from '@angular/core';
import { ChecklistHeaderApiService } from '../infra/api.service';
import { ChecklistHeader, ChecklistHeaderFindAllParams, ChecklistHeaderCreateParams } from './type';
import { User } from '../../user/core/type';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root', useClass: ChecklistHeaderApiService })
export abstract class ChecklistHeaderService extends BasicCrudService<
  ChecklistHeader,
  ChecklistHeader['id'],
  ChecklistHeaderFindAllParams,
  ChecklistHeader,
  ChecklistHeaderCreateParams
> {}
